'use client'

import { sendGenericEvent } from 'analytics/events/generics/sendGenericEvent'
import { LinkListClientItem } from 'fukku/ActionList/ListItem/LinkListItem/client/LinkListClientItem'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { MyRefundsClientLink } from 'links/myRefunds/client'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'

export const MyRefundsLink = () => {
	const { t } = useLabels()
	const {
		country: { refund },
	} = useMasterData()

	const linkTitle = 'profile.refunds.link'

	const onLinkClick = () => {
		sendGenericEvent('my_account_section', {
			label_1: linkTitle,
		})
	}

	return (
		refund?.enabled && (
			<LinkListClientItem
				title={t(linkTitle)}
				linkAs={MyRefundsClientLink}
				onClick={onLinkClick}
				titleUpperCase
			/>
		)
	)
}
